<template>
  <section>
    <div v-for="timeEntry in sortedEntries" :key="timeEntry.id" class="row whitespace-no-wrap">
      <TimeEntryRow
        :time-entry="timeEntry"
        :is-read-only="isReadOnly"
        v-on="$listeners"
        @on-delete="onDelete"
      />
    </div>
  </section>
</template>

<script>
import { TimeEntryCollection } from '/@/modules/timeentry/models/TimeEntryCollection';
import TimeEntryRow from '/@/modules/timeentry/components/stateful/TimeEntryRow.vue';
import { SortOrder } from '/@/modules/core/table/constants/TableConstant';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'TimeEntryRows',
  emits: ['on-delete'],
  components: { TimeEntryRow },
  props: {
    timeEntries: { type: TimeEntryCollection },
    isReadOnly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    sortedEntries() {
      return this.timeEntries
        .orderBy(['startedAt', 'createdAt'], [SortOrder.DESC, SortOrder.DESC])
        .get();
    }
  },
  methods: {
    onDelete(id) {
      this.timeEntries.delete(id);
      this.$emit('on-delete', id);
    }
  }
};
</script>

<style scoped>
div.row {
  width: 100%;
  border-bottom: 1px solid var(--ce-border);
  height: var(--ce-42px);
  background-color: var(--ce-white);

  &:hover {
    background-color: var(--ce-primary-light);
  }
}
</style>
